import type { RealtimeHandler } from "@/shared/realtime";

import { FRIENDS_QUERY_KEY } from "../api/FRIENDS_QUERY_KEY";

// `friends.updated` → друзей из Steam загрузили заново: экран перечитывается через REST.
// Повтор события — ещё одна инвалидация, данные те же.
export const handleFriendsUpdated: RealtimeHandler<"friends.updated"> = (
  _event,
  { queryClient },
) => {
  void queryClient.invalidateQueries({ queryKey: FRIENDS_QUERY_KEY });
};
